<template>
  <the-header></the-header>

  <!-- HERO COMPONENT -->
  <hero>
    <template v-slot:hero>
      <section class="flex items-start justify-between">
        <div class="text-left w-full md:w-1/2 md:mt-28">
          <h1
            class="text-indigo-600 text-2xl mt-8 md:mt-0 md:text-4xl font-bold"
          >
            SiBAN <span class="block pt-2">SiBAN Voting dAPP</span>
          </h1>
          <div class="mt-4">
            <p class="text-gray-600 text-sm  leading-loose">
              A decentralized community voting dApp for SiBAN elections.
            </p>
            <p class="text-gray-600 text-sm leading-loose">
              Real-time, open-source code smart contract voting system based on
              blockchain.
            </p>
            <p class="text-gray-600 text-sm leading-loose"></p>
          </div>
          <div class="mt-8">
            <p class="text-gray-600 text-sm leading-loose">
              The voting mechanism is automatic with
            </p>
            <p class="text-gray-600 text-sm leading-loose">
              just few clicks, your voting is registered
            </p>
          </div>
        </div>
        <div class="hidden md:block md:w-1/2 md:pt-24">
          <img class="w-screen" src="../assets/hero-illustration.png" alt="" />
        </div>
      </section>
    </template>
  </hero>

  <!-- CANDIDATES COMPONENT -->
  <candidates></candidates>

  <!-- HERO COMPONENT -->
  <hero>
    <template v-slot:hero>
      <!-- WHAT ARE WE ABOUT -->
      <section class="md:flex md:items-center md:justify-between">
        <div class="text-left pt-40 md:w-1/2 w-full">
          <h1 class="text-indigo-200 text-2xl md:text-3xl mb-8 font-medium">
            Features of <span class="text-indigo-600">SiBAN Voting dApp</span>
          </h1>
          <div class="mt-4">
            <p class="text-gray-600 text-sm md:text-lg leading-loose">
              1. Powered by Waves Blockchain Web 3.0 blockchain platform for
              building trustless apps and solutions.
            </p>
          </div>
          <div class="mt-8">
            <p class="text-gray-600 text-sm md:text-lg leading-loose">
              2. Transparent Votes are counted by smart contract deployed on the
              Waves decentralized blockchain. All operations are real-time and
              can be tracked by anyone on the go.
            </p>
          </div>
          <div class="mt-8">
            <p class="text-gray-600 text-sm md:text-lg leading-loose">
              3. Desktop and Mobile friendly Users can vote on their desktop or
              mobile devices. No need to install browser plugins to use the dApp
            </p>
          </div>
        </div>

        <div class="hidden md:block md:w-1/5">
          <img class="w-screen" src="../assets/application-form.png" alt="" />
        </div>
      </section>
    </template>
  </hero>
  <!-- FOOTER COMPONENT -->
  <the-footer> </the-footer>
  <!-- ADD Entrepreneur COMPONENT -->
</template>

<script>
import TheHeader from "../components/Nav/TheHeader.vue";
import Hero from "../components/UserInterface/Hero.vue";
import Candidates from "../components/UserInterface/Candidates.vue";
import TheFooter from "../components/Utilities/TheFooter";

export default {
  components: {
    TheHeader,
    Hero,
    Candidates,
    TheFooter,
  },
};
</script>
